export default async function getInterviewQuestionsApi(setQuestionList, setLoader, setActiveTab) {
  const temporaryQuestionSet = [
    {
      _id: "python-developer",
      name: "Python Developer",
      list: [
        {
          question: "What is the difference between a list and a tuple in Python?",
          answer:
            "A list is mutable, so you can add, remove, or change items. A tuple is immutable, so its contents cannot be changed after creation. Tuples are often used for fixed data and can be slightly faster and more memory efficient.",
        },
        {
          question: "What are decorators in Python and why are they useful?",
          answer:
            "Decorators are functions that take another function and extend or modify its behavior without changing its source code. They are useful for reusable cross-cutting concerns like logging, authentication, validation, and timing.",
        },
        {
          question: "Explain the Global Interpreter Lock (GIL) in Python.",
          answer:
            "The GIL is a lock in CPython that allows only one thread to execute Python bytecode at a time. It simplifies memory management but limits true parallel CPU-bound multithreading. For CPU-heavy tasks, multiprocessing is usually preferred.",
        },
        {
          question: "How do you handle exceptions properly in Python?",
          answer:
            "Use try-except blocks to catch expected errors, catch specific exception classes, and avoid bare except. Use finally for cleanup and raise to rethrow when needed. Custom exceptions help make error handling clearer in larger applications.",
        },
        {
          question: "What is the difference between deep copy and shallow copy?",
          answer:
            "A shallow copy creates a new container but keeps references to nested objects. A deep copy creates a new container and recursively copies nested objects as well. Use copy.copy for shallow copy and copy.deepcopy for deep copy.",
        },
      ],
    },
  ];

  setQuestionList(temporaryQuestionSet);
  setActiveTab(temporaryQuestionSet[0]._id);
  setLoader(false);
}
